import React from 'react';
import PageHeader from './PageHeader';
import PageTitle from './PageTitle';
import LinearChart from "./LinearChart";
import {ITPColorsLegend} from "../constants";
import ReportService from "../../services/ReportService";

const Results = ({ assessment = null, scoring = null }) => {
	const valueCounts = {};
	const weakest = assessment?.sortedScore?.[2]?.[0];
	Object.values(assessment?.score).forEach(value => {
		valueCounts[value] = (valueCounts[value] || 0) + 1;
	});

	let tieCount = 0;
	for (let count of Object.values(valueCounts)) {
		if (count > 1) {
			tieCount += 1;
		}
	}
	return (
		<div className='ChartResults'>
			<PageHeader title={'Results'} />
			<div className='container result-description'>
				<PageTitle title={'Your Results'}/>
				<p className={'font-bold text-[10pt] py-4'}>
					{assessment?.firstName}, the information below summarizes the results of your assessment.
				</p>
				<div className='resultset itp'>
					<p className={'resultset-description'} key={'result-description'}
						dangerouslySetInnerHTML={{
						__html: ReportService.ITPResultDescriptionMapping[tieCount](assessment?.firstName, weakest),
					}}>
					</p>
					{
						scoring?.map(({key, description, score}, index) => {
							return (
								<>
									<p className={'font-bold text-[11pt] mt-6 ml-8'}>{index+1}.<span className={'ml-1'}>{key}</span></p>
									<p className={'font-light text-[10pt] ml-8 mr-8'}>{description}</p>
									<div className={'ml-8 mr-8 mt-1'}>
										<LinearChart score={ReportService.formatITPScore(score)} chart_height={'h-7/12'} score_position={'-10%'}/>
									</div>
								</>
							)
						})
					}
				</div>
				<div className="pt-4">
					<h3 className="text-lg font-semibold mb-3">Legend</h3>
					<div className="flex space-x-6">
						{
							Object.values(ITPColorsLegend)
								.sort((a, b) => a.min - b.min)
								.map(({ min, max, color }, index) => {
									const range = `${min} - ${max}`;
									return (
										<div
											key={`Color-Legend-${color}-${index}`}
											className="flex flex-col items-center mx-2"
										>
											<div
												className="w-6 h-6"
												style={{ backgroundColor: color }}
												key={`Legend-Color-Legend-${color}-${index}`}
											/>
											<span className="mt-1 text-sm font-semibold text-center">{range}</span>
										</div>
									);
								})
						}
					</div>
				</div>
			</div>
		</div>
	);
};

export default Results;
